export const USER_ACTION_START_MESSAGE_TYPE = 'user-action-start';
export const USER_ACTION_END_MESSAGE_TYPE = 'user-action-end';
export const USER_ACTION_CANCEL_MESSAGE_TYPE = 'user-action-cancel';
//# sourceMappingURL=const.js.map